/**
 * Use for documenting and debugging assumptions.
 */
export default function assert(val, ...msg) {
	if (val) return;
	throw new Error(msg?.join(" ") || 'Assertion failed');
}